<template>
<div>
  <div class="container-fluid top-container">
    <div class="row banner-div">
      <div class="col-lg-6 title-div">
        <img
          class="archivio-vivo-logo img-fluid"
          src="../assets/images/archiviovivo_logo.png"
        >
        <h1 class="maintitle fw-bold">
          ARCHIVIO
          <span class="vivofont">Vi.Vo.</span>
        </h1>
        <h2 class="subtitle">
          Conservazione e diffusione
          <br>
          degli archivi orali.
        </h2>
        <div>
          <br>
          <button class="btn btn-warning">
            <span class="button-custom-span">
              <i class="bi bi-tools"></i>
              In sviluppo...
            </span>
          </button>
        </div>
      </div>
      <div class="col-lg-6 feed-div">
        <keep-alive>
          <div
            class="fb-page"
            data-href="https://www.facebook.com/archivioVi.Vo/"
            data-tabs="timeline"
            data-width="400"
            data-height="400"
            data-small-header="true"
            data-adapt-container-width="true"
            data-hide-cover="true"
            data-show-facepile="true"
          >
            <blockquote
              cite="https://www.facebook.com/archivioVi.Vo/"
              class="fb-xfbml-parse-ignore"
            >
              <a href="https://www.facebook.com/archivioVi.Vo/">Archivio Vi.Vo.</a>
            </blockquote>
          </div>
        </keep-alive>
      </div>
    </div>
  </div>
  <div class="separator">
    <span id="bottom-arrow">
      <i class="bi bi-caret-down-fill"></i>
    </span>
  </div>
  <!--  -->
  <section id="informations">
    <div class="info-row">
      <div
        class="row row-cols-1 row-cols-lg-3 g-4 mx-auto mt-2"
        style="max-width:1400px"
      >
        <div class="col mt-2">
          <div class="card h-100 custom-card ml-auto mr-auto">
            <router-link
              to="/patrimonio-audiovisivo"
              class="card-link"
            >
              <img
                src="../assets/images/copiaconservativa.png"
                class="card-img-top"
                alt="cc"
              >
            </router-link>
            <div class="card-body">
              <h5 class="card-title">
                <router-link
                  to="/patrimonio-audiovisivo"
                  class="card-link"
                >Patrimonio Audiovisivo</router-link>
              </h5>
              <p class="card-text">Gli archivi audiovisivi raccolgono un patrimonio prezioso e allo stesso tempo fragile, che necessita di interventi mirati per garantire la salvaguardia e l’accessibilità dei dati.</p>
            </div>
          </div>
        </div>
        <div class="col mt-2">
          <div class="card h-100 custom-card ml-auto mr-auto">
            <router-link
              to="/caterina-bueno"
              class="card-link"
            >
              <img
                src="../assets/images/caterina-bueno.jpg"
                class="card-img-top"
                alt="caterina-bueno"
              >
            </router-link>
            <div class="card-body">
              <h5 class="card-title">
                <router-link
                  to="/caterina-bueno"
                  class="card-link"
                >Caterina Bueno</router-link>
              </h5>
              <p class="card-text">L'archivio sonoro di Caterina Bueno è composto da 476 supporti, corrispondenti a quasi 714 ore di registrazione digitalizzate durante il progetto PAR-FAS Gra.fo.</p>
            </div>
          </div>
        </div>
        <div class="col mt-2">
          <div class="card h-100 custom-card ml-auto mr-auto">
            <router-link
              to="/clarin-it"
              class="card-link"
            >
              <img
                src="../assets/images/clarin-it.jpg"
                class="card-img-top"
                alt="clarin-it"
              >
            </router-link>
            <div class="card-body">
              <h5 class="card-title">
                <router-link
                  to="/clarin-it"
                  class="card-link"
                >Clarin-IT</router-link>
              </h5>
              <p class="card-text">Il consorzio italiano di CLARIN, CLARIN-IT, mira ad integrare a livello europeo strumenti avanzati di ricerca, di accesso e di analisi dei contenuti digitali per le risorse linguistiche.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <hr>
  <section
    id="partners"
    style="max-width:1400px"
  >
    <h3 style="margin-bottom: 20px;">Partners</h3>
    <div class="row">
      <div class="col-lg-2 col-md-6">
        <img
          class="partner-logo"
          src="../assets/images/regionetoscanalogo.png"
        >
      </div>
      <div class="col-lg-2 col-md-6">
        <img
          class="partner-logo"
          src="../assets/images/unisi_logo_trasparente.png"
        >
      </div>
      <div class="col-lg-2 col-md-6">
        <img
          class="partner-logo"
          src="../assets/images/bibliografica_logo.png"
        >
      </div>
      <div class="col-lg-2 col-md-6">
        <img
          class="partner-logo"
          src="../assets/images/ilc_logo.png"
        >
      </div>
      <div class="col-lg-2 col-md-6">
        <img
          class="partner-logo"
          src="../assets/images/clarinitlogo.png"
        >
      </div>
      <div class="col-lg-2 col-md-6">
        <img
          class="partner-logo"
          src="../assets/images/casentino_unione_logo.png"
        >
      </div>
    </div>
  </section>
</div>
</template>
<script>
export default {
  mounted() {
    document
      .getElementById("bottom-arrow")
      .addEventListener("click", function () {
        document.querySelector("#informations").scrollIntoView({
          behavior: "smooth",
        });
      });
  },
};
</script>